import { UserService } from '@app/user';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '@app/service/message.service';
import { Injectable } from '@angular/core';
import { FileErrorTypes } from '../../models';
import { subtitlesConfig } from '../../config/subtitles.config';

@Injectable()
export class SubtitlesErrorService {
    constructor(
        private messageService: MessageService,
        private translateService: TranslateService,
        private userService: UserService,
    ) {}

    setError(errorTypes: FileErrorTypes) {
        const error = subtitlesConfig.errors.find((error) => error.id === errorTypes);

        if (!error) return '';

        switch (error.id) {
            case 'extension': {
                const message = this.translateService.instant(error.text, {
                    extensions: error.extensions.map((key) => this.translateService.instant(key)).join(', '),
                });
                this.messageService.setMessage(message, 'warning');
                return;
            }
            case 'size': {
                const message = this.translateService.instant(error.text);
                this.messageService.setMessage(message, 'warning');
                return;
            }
            case 'virus': {
                const message = this.translateService.instant(error.text);
                this.messageService.setMessage(message, 'danger');
                return;
            }
            case 'storage': {
                const message = this.translateService.instant(error.text, {
                    value: this.translateService.instant(error.value, { size: this.userService.user.company.hostedCustomContent?.maxStorageSize / 1000 }),
                });
                this.messageService.setMessage(message, 'warning');
                return;
            }
        }
    }
}
